
// Provides a UI for viewing and interacting with stripe payment methods
export class PaymentMethods extends HTMLElement {
  constructor(groupId, previousViewId) {
    super();
    this.groupId = groupId
    this.previousViewId = previousViewId
  }

  connectedCallback() {
    this.innerHTML = `
    <style>
      #payment_methods {
        margin-bottom:20px;
      }
      #unverified_payment_methods_container {
        display:none;
      }
      
      #addPaymethMethod .modal-dialog {
        height:unset;
      }
      
      #default_payment_method {
        background-color: #CFF5F6;
        font-weight:700;
        padding:4px 4px;
        margin-left:8px;
        border-radius:6px;
      }

      .delete-payment-method{
        color:red;
      }
      
      .payment_method {
        border:1px solid #aaa;
        border-radius:6px;
        padding:12px;
        margin-top:20px;
      }
    </style>
  
    <div class="row" style="padding-bottom: 8px">
      <div class="col-sm-12">
        <a 
          class="btn btn-primary pull-right" 
          id="create_payment_method" 
          data-toggle="modal" 
          data-target="#addPaymethMethod"
          >Add Payment Method
        </a>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div id='payment_methods_container'>
          <h3>Payment Methods</h3>
          <div id='payment_methods'></div>
        </div>

        <div id='unverified_payment_methods_container'>
          <h3>Unverfied Payment Methods</h3>
          <div id='unverified_payment_methods'></div>
        </div>
      </div>  
    </div>
    `

    this.init();
  }

  init() {
    if (! this.groupId){
      this.groupId = this.getAttribute('groupId')
    }
    if (! this.groupId) {
      console.log("Missing groupId parameter.")
      return
    }

    this.getPaymentMethods()

    this.appendChild(new AddPaymentMethodModal(this.groupId));
  }

  cancelEdit(e) {
    e.preventDefault();
    this.remove();
    document.getElementById(this.previousViewId).style.display = 'initial';
  }

  async getPaymentMethods() {    
    const url = `/admin/groups/${this.groupId}/payment_methods`
    let res = await fetch(url);
    let result = await res.json();
    // console.log('payment methods: ' + JSON.stringify(result))

    if (result['payment_methods'].length === 0) {
      this.renderNoResults()
    }
    else {
       const container = this.querySelector('#payment_methods')
      if (container) {
        let html = ''
        for (let i of result['payment_methods']) {
          html += this.renderPaymentMethod(i, result['default_payment_id'])
        }
        container.innerHTML = html
      }

      document.querySelectorAll(".default-payment-method").forEach((elem) => {
        elem.addEventListener("click", async function (e) {
          e.preventDefault();
          this.defaultPaymentMethod(e.target)
        }.bind(this));
      })

      document.querySelectorAll(".delete-payment-method").forEach((elem) => {
        elem.addEventListener("click", async function (e) {
          e.preventDefault();
          let conf = await confirmPlus(`Are you sure you want to delete this payment method?`, 'Delete Payment Method');
          if (conf) {
            this.deletePaymentMethod(e.target)
          }
        }.bind(this));
      })
    }

    this.renderUnverifiedPaymentMethods(result['unverified_payment_methods'])
  }
  
  renderUnverifiedPaymentMethods(unverified_payment_methods) {
    if (unverified_payment_methods.length === 0) {
      document.getElementById('unverified_payment_methods_container').style.display = 'none';
      return;
    }

    let result = '';
    const container = this.querySelector('#unverified_payment_methods')
    if (container) {
      let html = ''
      for (let i of unverified_payment_methods) {
        html += this.renderUnverfieidPaymentMethod(i)
      }
      container.innerHTML = html
      document.getElementById('unverified_payment_methods_container').style.display = 'initial';
    }  
  }
  
  renderUnverfieidPaymentMethod(data) {
    // console.log('unverified payment method: ' + JSON.stringify(data))

    let html = ''
    if (data.stripe_payment_method_type === 'card') {
      html = `
        <div class="row payment_method">
          <div class="payment_method_wrapper col-sm-6 col-md-6 no-gutters">
            <div>
              <span>
                <span>Credit Card: ${this.capitalizeFirstLetter(data.card.brand)}</span>
                ending in <span>${data.card.last4}</span>
              </span>
              ${default_html}
              <br/>
              <span>Expires: ${data.card.exp_month}/${data.card.exp_year}</span>
            </div>
          </div>
          ${
            `<div class="text-right col-sm-6 col-md-6 no-gutters">
              ${make_default_html}
              <a 
                href='#' 
                class="btn-link delete-payment-method" 
                title="Delete this payment method"
                data_stripe_payment_method_id=${data.id}>
                Delete
              </a>
            </div>`
          }
        </div>      
      `
    }
    else if (data.stripe_payment_method_type === 'us_bank_account') {
      html = `
        <div class="row payment_method">
          <div class="payment_method_wrapper col-sm-6 col-md-6 no-gutters">
            <div>
              <span>
                <span>Bank Account: ${data.stripe_default_payment_method_description}</span>                </span>
            </div>
          </div>
          ${
            `<div class="text-right col-sm-6 col-md-6 no-gutters">
              <a 
                href=${data.stripe_verification_url}
                target='_blank' 
                class="btn-link verify-payment-method" 
                title="Verify this payment method"
              >
                Verify
              </a>
            </div>`
          }
        </div>      
      `
    }
    return html 
  }

  
  // this should be in common.js but I could not get it to work.
  findAncestorByClass(el, cls) {
    while ((typeof el !== 'undefined') && (el = el.parentNode) && el.className.indexOf(cls) < 0);
    if (typeof el === 'undefined') { el = null;}
    return el;
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  renderPaymentMethod(data, default_payment_id) {
    // console.log('payment method: ' + JSON.stringify(data))
    const is_default = default_payment_id === data.id
    let default_html = ''
    let make_default_html = `
                <a 
                  href='#' 
                  class="btn-link default-payment-method" 
                  title="Make this the default payment method"
                  data_stripe_payment_method_id=${data.id}>
                  Set as Default
                </a>
                &nbsp;|&nbsp;    
    `
    if (is_default){
      default_html = `<span id='default_payment_method'>Default</span>`
      make_default_html = ''
    }
    
    let html = ''
      if (data.type === 'card') {
        html = `
          <div class="row payment_method">
            <div class="payment_method_wrapper col-sm-6 col-md-6 no-gutters">
              <div>
                <span>
                  <span>Credit Card: ${this.capitalizeFirstLetter(data.card.brand)}</span>
                  ending in <span>${data.card.last4}</span>
                </span>
                ${default_html}
                <br/>
                <span>Expires: ${data.card.exp_month}/${data.card.exp_year}</span>
              </div>
            </div>
            ${
              is_default ? '' :
              `<div class="text-right col-sm-6 col-md-6 no-gutters">
                ${make_default_html}
                <a 
                  href='#' 
                  class="btn-link delete-payment-method" 
                  title="Delete this payment method"
                  data_stripe_payment_method_id=${data.id}>
                  Delete
                </a>
              </div>`
            }
          </div>      
        `
      }
      else if (data.type === 'us_bank_account') {
        html = `
          <div class="row payment_method">
            <div class="payment_method_wrapper col-sm-6 col-md-6 no-gutters">
              <div>
                <span>
                  <span>Bank Account: ${data.us_bank_account.bank_name}</span>
                  ending in <span>${data.us_bank_account.last4}</span>
                </span>
                ${default_html}
              </div>
            </div>
            ${
              is_default ? '' :
              `<div class="text-right col-sm-6 col-md-6 no-gutters">
                ${make_default_html}
                <a 
                  href='#' 
                  class="btn-link delete-payment-method" 
                  title="Delete this payment method"
                  data_stripe_payment_method_id=${data.id}>
                  Delete
                </a>
              </div>`
            }
          </div>      
        `
      }
    return html 
  }

  async defaultPaymentMethod(obj) {
    const stripe_payment_method_id = obj.getAttribute('data_stripe_payment_method_id')
    // console.log('delete: ' + stripe_payment_method_id)
    const row = this.findAncestorByClass(obj, "payment_method")
    if (! row) {
      console.log('payment_method ancestor not found')
      return
    }

    await this.makePaymentMethodDefault(stripe_payment_method_id)
  }

  async makePaymentMethodDefault(stripe_payment_method_id) {
    pageLoadingFrame("show")
    const url = `/admin/groups/${this.groupId}/default_payment_method`
    let res = await fetch(url,{
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: `{"stripe_id":"${stripe_payment_method_id}"}`
    });

    let result = await res.json();
    //console.log('delete payment method result: ' + JSON.stringify(result))
    if (result.payment_method.error) {
      console.log(`[default_payment_method] Error: ${result.payment_method.error}`);
    }
    else if (result.payment_method.id !== stripe_payment_method_id) {
      await this.getPaymentMethods()
    }
    pageLoadingFrame("hide")
  }

  async deletePaymentMethod(obj) {
    const stripe_payment_method_id = obj.getAttribute('data_stripe_payment_method_id')
    // console.log('delete: ' + stripe_payment_method_id)
    const row = this.findAncestorByClass(obj, "payment_method")
    if (! row) {
      console.log('payment_method ancestor not found')
      return
    }

    let res = await this._deletePaymentMethod(stripe_payment_method_id)
    let result = await res.json();
    // console.log('delete payment method result: ' + JSON.stringify(result))
    if (result.payment_method.id === stripe_payment_method_id) {
      row.remove();
    }

    await this.getPaymentMethods()
  }

  async _deletePaymentMethod(stripe_payment_method_id){
    pageLoadingFrame("show")
    const url = `/admin/groups/${this.groupId}/payment_method`
    let res = await fetch(url,{
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'DELETE',
      body: `{"stripe_id":"${stripe_payment_method_id}"}`
    });
    pageLoadingFrame("hide")
    return res
  }
  
  
  renderNoResults() {
    const container = this.querySelector('#payment_methods')
    if (container) {
      const p = document.createElement('p')
      const message = document.createElement('h4')
      message.textContent = "No payment method found. Click the 'Add Payment Method' button to create your first payment method."
      p.append(message)
      container.append(p)
    }
  }

  
  // Adds or removes a facebook style notification to the billing tab
  // based on if there are any unpaid invoices.
  handleUnpaidInvoiceCount(count, message) {
    if (count > 0) {
      let span = this.querySelector('.notification.badge')
      if (span === null) {
        span = document.createElement('span')
        span.className = 'notification badge'
        span.textContent = count
        span.title = message
        this.append(span)
      }
    }
    else {
      let span = this.querySelector('.notification.badge')
      if (span !== null) {
        span.delete()
      }
    }
  }
}
customElements.define("payment-methods", PaymentMethods)


class AddPaymentMethodModal extends HTMLElement {
  constructor(groupId) {
    super();
    this.groupId = groupId
  }

  connectedCallback() {
    this.innerHTML = `
    <style>
      add-location-modal {
        font-size: 14px;
      }

      #error-message{
        color:red;
      }
    </style>
    <div class="modal fade" id="addPaymethMethod" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Payment Method</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
          </div>
        </div>
      </div>
    </div>`

    this.init()
  }

  async init() {
    // wait until the modal is shown to get a payment intent
    $('#addPaymethMethod').on('show.bs.modal', async function () {
      this.initModal()
    }.bind(this))
 
     $('#addPaymethMethod').on('hidden.bs.modal', async function () {
      this.modalBody.innerHTML = ''
    }.bind(this))
  }


  close(){
    $(this.modal).modal('hide');
  }

  // need this data so we can prevent duplicate cards being added
  async getPaymentMethodFingerprints() {
    const url = `/admin/groups/${this.groupId}/payment_method_fingerprints`
    let res = await fetch(url);
    const {fingerprints} = await res.json();
    this.existing_fingerprints = fingerprints
    // console.log('existing: ' + this.existing_fingerprints)
  }
  

    async initModal() {
    await this.getPaymentMethodFingerprints()
    this.modal = this.querySelector('.modal#addPaymethMethod');
    this.modalBody = this.querySelector('.modal#addPaymethMethod .modal-body');
    // we want to rebuild this each time the modal is displayed to ensure stripe elements is happy and clean.
    //this.modalBody.innerHTML = `<h5 class='text-center'>Please wait. Loading...</h5>`

    const url = `/admin/groups/${this.groupId}/payment_method_intent`
    let res = await fetch(url);
    let result = await res.json();
    const stripe = Stripe(result.public_key)
    const options = {
      clientSecret: result.client_secret,
    };

    
    // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 2
    const elements = stripe.elements(options);

    // Create and mount the Payment Element
    const paymentElement = elements.create('payment');

    this.modalBody.innerHTML = `
            <form id="payment-form" class="hide">
              <div id="payment-element"></div>
              <div class="row" style="margin-top:10px;">
                <button class='btn btn-primary pull-right' id="submit">Submit</button>
                <h3 id="error-message"></h3>
              </div>
            </form>   `  

    paymentElement.mount('#payment-element');    

    paymentElement.on('ready', function(e){
      document.getElementById('payment-form').classList.remove('hide')
    })

    // https://stripe.com/docs/payments/save-and-reuse?platform=web&html-or-react=html#customize-appearance
    const form = document.getElementById('payment-form');
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      this.changeLoadingState(true);
      const {error, setupIntent} = await stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements,
        redirect: 'if_required',
        confirmParams: {
          return_url: 'https://example.com/account/payments/setup-complete',
        }
      });  
      this.changeLoadingState(false);

      if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        const messageContainer = document.querySelector('#error-message');
        messageContainer.textContent = error.message;
      } else {
        this.handleSetupIntent(setupIntent, paymentElement)
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }
    })
  }  

  async handleSetupIntent(setupIntent, paymentElement) {
    const { fingerprint } = await fetch("/admin/groups/fingerprint", {
      method: "POST",
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
              'Content-type': 'application/json'},
      body: JSON.stringify({paymentMethodId: setupIntent.payment_method}),
    }).then((r) => r.json());
    console.log(`Got the fingerprint for ${setupIntent.payment_method}, which is ${fingerprint}`);
    

    const duplicates = this.existing_fingerprints.filter((pm) => pm === fingerprint);
    console.log('duplicates: ' + duplicates)
    if (duplicates.length > 0){
      this.errorMessage("This card is a duplicate.")
      paymentElement.clear()
      // delete the duplicate payment method
      await this._deletePaymentMethod(setupIntent.payment_method)
      this.changeLoadingState(false);
      return
    }

    this.close()
    Common.notify("Payment Method added.", "success")

    // Force the first payment method to be the default method
    if (this.existing_fingerprints.length === 0) {
      await document.getElementsByTagName('payment-methods')[0].makePaymentMethodDefault(setupIntent.payment_method)
    }
    document.getElementsByTagName('payment-methods')[0].getPaymentMethods()
  }

  async _deletePaymentMethod(stripe_payment_method_id){
    const url = `/admin/groups/${this.groupId}/payment_method`
    let res = await fetch(url,{
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'DELETE',
      body: `{"stripe_id":"${stripe_payment_method_id}"}`
    });
    return res
  }

  errorMessage(msg){
    const messageContainer = document.querySelector('#error-message');
    if (messageContainer) {
      messageContainer.textContent = msg;
    }

    if ( msg.length > 0 ) {
      console.log(`Stripe Error: ${msg}`)
    }
  }
  
  changeLoadingState(loading) {
    if (loading) {
      document.querySelector("button#submit").disabled = true;
      this.errorMessage('') 
    }
    else {
      document.querySelector("button#submit").disabled = false;
    }
  }
}

customElements.define("add-payment-method-modal", AddPaymentMethodModal);

